import logo from '@assets/images/woah_primary_logo_english_orange.png';
import logoFR from '@assets/images/woah_primary_logo_french_orange.png';
import logoES from '@assets/images/woah_primary_logo_spanish_orange.png';
import { getImageRatio } from '@utils/getImageRatio';
import { Image, XStack } from 'tamagui';
import { useAppTranslation } from '@hooks/useAppTranslation';
import { useMemo } from 'react';
import { SupportedLanguage } from '@store/i18n';

export interface LogoProps {
  height?: number | string;
  width?: number | string;
}

export function Logo({ height = 44, width }: LogoProps): React.ReactNode {
  const { language } = useAppTranslation();
  const translatedLogo = useMemo(() => {
    switch (language) {
      case SupportedLanguage.en:
        return logo;
      case SupportedLanguage.fr:
        return logoFR;
      case SupportedLanguage.es:
        return logoES;
    }
  }, [language]);

  return (
    <XStack
      width={width}
      height={height}
      aspectRatio={getImageRatio(logo)}
      flexShrink={0}
    >
      <Image
        source={translatedLogo}
        style={{ width: '100%', height: '100%', resizeMode: 'contain' }}
      />
    </XStack>
  );
}
